import { Component, HostBinding } from '@angular/core';

@Component({
  moduleId: String(module.id),
  selector: 'kui-nav-section',
  templateUrl: './nav-section.component.html',
})
export class KuiNavSectionComponent {
  @HostBinding('class.nav-section') nav_section = true;
}
